import type { NavItem as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'

export type SerializedNavItem = Model

export default class NavItem implements CamelCaseKeys<SerializedNavItem> {
    label?: Model['label']

    route?: Model['route']

    redirect?: Model['redirect']

    secondary?: Model['secondary']

    constructor(values: NavItem) {
        Object.assign(this, values)
    }
}
